import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionApply } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionApply";
import { WrapCashContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContribution";
import { GiaModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/InvestmentAccount/GiaModel";
import { IsaModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Isa/IsaModel";

export const inUseBankAccountForApply = (data: any): string[] => {
    let inUseBankAccount: string[] = [];
    if (!CommonHelper.isNullOrEmpty(data?.GiaModel)) {
        inUseBankAccount = inUseBankAccount.concat(inUseBankAccountForContribution(data?.GiaModel));
    }
    if (!CommonHelper.isNullOrEmpty(data?.IsaModel)) {
        inUseBankAccount = inUseBankAccount.concat(inUseBankAccountForContribution(data?.IsaModel));
    }
    if (!CommonHelper.isNullOrEmpty(data?.PensionApply)) {
        inUseBankAccount = inUseBankAccount.concat(inUseBankAccountForContribution(data?.PensionApply));
    }
    if (!CommonHelper.isNullOrEmpty(data?.WrapCashModel)) {
        inUseBankAccount = inUseBankAccount.concat(inUseBankAccountForContribution(data?.WrapCashModel));
    }
    if (!CommonHelper.isNullOrEmpty(data?.Contribution)) {
        inUseBankAccount = inUseBankAccount.concat(inUseBankAccountForContribution(data?.Contribution));
    }
    return inUseBankAccount;
};

export const inUseBankAccountForContribution = (
    data: PensionApply | GiaModel | IsaModel | WrapCashContribution
): string[] => {
    const inUseBankAccount: string[] = [];
    if (!CommonHelper.isNullOrEmpty(data?.ClientSinglePayment?.BankAccountNumber)) {
        inUseBankAccount.push(data?.ClientSinglePayment?.BankAccountNumber);
    }
    if (!CommonHelper.isNullOrEmpty(data?.ClientRegularPayment?.BankAccountNumber)) {
        inUseBankAccount.push(data?.ClientRegularPayment?.BankAccountNumber);
    }
    if (!CommonHelper.isNullOrEmpty(data?.ThirdPartyRegularPayment?.BankAccountNumber)) {
        inUseBankAccount.push(data?.ThirdPartyRegularPayment?.BankAccountNumber);
    }
    if (!CommonHelper.isNullOrEmpty(data?.ThirdPartySinglePayment?.BankAccountNumber)) {
        inUseBankAccount.push(data?.ThirdPartySinglePayment?.BankAccountNumber);
    }
    if (!CommonHelper.isNullOrEmpty((data as PensionApply)?.EmployerSinglePayment?.BankAccountNumber)) {
        inUseBankAccount.push((data as PensionApply)?.EmployerSinglePayment?.BankAccountNumber);
    }
    if (!CommonHelper.isNullOrEmpty((data as PensionApply)?.EmployerRegularPayment?.BankAccountNumber)) {
        inUseBankAccount.push((data as PensionApply)?.EmployerRegularPayment?.BankAccountNumber);
    }
    return inUseBankAccount;
};
